import { Pipe, PipeTransform } from '@angular/core';
import { Team } from '@athlete-x/definitions';

@Pipe({
    name: 'teamMember',
    standalone: true
})
export class TeamMemberPipe implements PipeTransform {

    transform(teams: Array<Team>): Array<Team> {
        if (!teams?.length) {
            return teams;
        }

        return teams.filter((t) => {
            return t.status === 'active';
        })
    }

}
